import React from 'react';
import PageHeader from '../common/PageHeader';
import BulkUnos from '../TachoBulk/BulkUnos';

/* "Taho listići": jedna slika analognog listića — isti motor i pregled kao Bulk listići (TachoBulk/engine):
   automatski krug, obrazac (Kienzle / BLU-8-125 DUAL / BLU-2-125-EC), rotacija i aktivnosti; izmena na slici i u tabeli,
   ručno nameštanje listića, UTC prikaz, dani listića sa spajanjem i čuvanje kao u Bulk-u.
   (Ranije: ručno sečenje, rotacija i crtanje kupa — coneCanvas.js / autogenerate.js se više ne koriste.) */
export default function TachoAnalyzer({ active }) {
    return (
        <>
            <PageHeader title="Taho listići" subtitle="Jedan listić: motor sam pronalazi listić, poravnava skalu i čita aktivnosti — vi proveravate i upisujete." />
            <BulkUnos active={active} jedan />
        </>
    );
}
